module.exports = __webpack_public_path__ + "static/img/1667304271431790.499b463.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/energy/1667304271431790.jpg
// module id = WZk+
// module chunks = 4